export const respStyleObject = object => {
    const keys = ['_', 'xs', 'sm', 'ms', 'md', 'l', 'xl', 'xxl', 'adL', 'huge'];
    return keys.map(item => object[item] || null);
};
